/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GroupResp } from '../../models/group-resp';

export interface ApiManagementGroupGetAllGet$Params {
}

export function apiManagementGroupGetAllGet(http: HttpClient, rootUrl: string, params?: ApiManagementGroupGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GroupResp>>> {
  const rb = new RequestBuilder(rootUrl, apiManagementGroupGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GroupResp>>;
    })
  );
}

apiManagementGroupGetAllGet.PATH = '/api/Management/Group/GetAll';
